/* eslint-disable react/no-unescaped-entities */
import { FC, useEffect, useState } from "react";
import { useRouter } from "next/router";
import CompetitionList from "components/atoms/CompetitionList";
import { getActiveCompetitions, getArchivedCompetitions } from "lib/actions";
import { CompetitionDTO } from "types";
import { SubTitle, Text } from "utils/styling/typography.styled";
import * as Styled from "./CompetitionLanding.styled";
export const CompetitionLanding: FC = () => {
  const [activeCompetitions, setActiveCompetitions] = useState<CompetitionDTO[]>([]);
  const [archivedCompetitions, setArchivedCompetitions] = useState<CompetitionDTO[]>([]);
  useEffect(() => {
    const fetchCompetitions = async () => {
      try {
        const activeResponse = await getActiveCompetitions();
        const archivedResponse = await getArchivedCompetitions();
        if (!activeResponse.error || !archivedResponse.error) {
          setActiveCompetitions(activeResponse.competition ?? []);
          setArchivedCompetitions((archivedResponse.competition ?? []).sort((a, b) => a.endDate.localeCompare(b.endDate)));
        }
      } catch (e) {
        setActiveCompetitions([]);
        setArchivedCompetitions([]);
      }
    };
    fetchCompetitions();
  }, []);
  const router = useRouter();
  const handleCompetitionClick = (id: string) => {
    router.push(`/competitions/${id}`);
  };
  return <Styled.Container data-sentry-element="unknown" data-sentry-component="CompetitionLanding" data-sentry-source-file="index.tsx">
            <Styled.Header data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                <SubTitle data-sentry-element="SubTitle" data-sentry-source-file="index.tsx">CharGen Competitions</SubTitle>
                <br />
                <Text data-sentry-element="Text" data-sentry-source-file="index.tsx">
                    Participate in CharGen's exciting AI-generated D&D character
                    art competitions. Compete for fantastic prizes.
                </Text>
            </Styled.Header>
            <Styled.Section data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                <Styled.SectionTitle data-sentry-element="unknown" data-sentry-source-file="index.tsx">Active Competitions</Styled.SectionTitle>
                <CompetitionList competitions={activeCompetitions} onCompetitionClick={handleCompetitionClick} data-sentry-element="CompetitionList" data-sentry-source-file="index.tsx" />
            </Styled.Section>
            <Styled.Section data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                <Styled.SectionTitle data-sentry-element="unknown" data-sentry-source-file="index.tsx">Archived Competitions</Styled.SectionTitle>
                <CompetitionList competitions={archivedCompetitions} onCompetitionClick={handleCompetitionClick} archived data-sentry-element="CompetitionList" data-sentry-source-file="index.tsx" />
            </Styled.Section>
            <Styled.HorizontalRule data-sentry-element="unknown" data-sentry-source-file="index.tsx" />
            <Styled.FaqSection data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                <Styled.FaqTitle data-sentry-element="unknown" data-sentry-source-file="index.tsx">Frequently Asked Questions</Styled.FaqTitle>
                <Styled.Faq data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    <Styled.Question data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                        How do I enter the competition?
                    </Styled.Question>
                    <Styled.Answer data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                        To enter the competition, simply generate your art
                        following the competition guidelines and submit your
                        entry on our platform.
                        <br />
                        Search in your gallery for images that meet the criteria
                        or generate new images to enter the competition.
                        <br />
                        Only one image is eligible per competition per user. If
                        you have already submitted an image, you can submit a
                        new one and choose to rescind the previous submission.
                        <br />
                        Entries which have already won previous competitions
                        will not be eligible for entry into future competitions
                        to ensure fairness.
                        <br />
                        Images eligible for entry must meet all the criteria
                        requirements. For example, if the criteria include "Art
                        Style: Comic Book Illustration" and "Race: Goblin", then
                        only images that match both criteria will be eligible.
                    </Styled.Answer>
                </Styled.Faq>
                <Styled.Faq data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    <Styled.Question data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                        How are the winners selected?
                    </Styled.Question>
                    <Styled.Answer data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                        Winners are selected based on community votes as well as
                        a special choice by our team. Make sure to share your
                        entry and gather as many votes as possible! Winners will
                        be notified automatically, and prizes will be granted
                        accordingly.
                    </Styled.Answer>
                </Styled.Faq>
                <Styled.Faq data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    <Styled.Question data-sentry-element="unknown" data-sentry-source-file="index.tsx">What are the prizes?</Styled.Question>
                    <Styled.Answer data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                        Prizes vary for each competition. Check the competition
                        details for specific information about the rewards.
                    </Styled.Answer>
                </Styled.Faq>
            </Styled.FaqSection>
        </Styled.Container>;
};